const DEFAULT_SCROLL_TIMEOUT = 50;

export const scrollBackToTop = (
	behavior: ScrollBehavior = 'smooth',
	callback?: () => void,
	callbackTimeout?: number
) => {
	if (typeof window !== 'undefined') {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior
		});

		if (callback) {
			setTimeout(callback, callbackTimeout ?? DEFAULT_SCROLL_TIMEOUT);
		}
	}
};
